import React, { useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import Select from 'components/forms/Select'
import { useDispatch } from 'react-redux'
import { range } from 'lodash'
import { push } from '@lagunovsky/redux-react-router'
import RpqsAction from 'rpqs/actions/RpqsAction'
import ToastrAction from 'toastr/actions/ToastrAction'
import moment from 'moment'

const FIRST_YEAR = 1980

// Duplication d'un RPQS : on choisit l'année du nouveau RPQS parmi celles qui n'existent
// pas encore pour la collectivité (de l'année courante jusqu'à 1980).
const DialogDuplicateRPQS = ({
    open = false,
    onClose = () => {},
    sourceRpqs = {},
    existingYears = [],
}) => {
    const dispatch = useDispatch()
    const [year, setYear] = useState()

    const currentYear = moment().year()
    const takenYears = existingYears.reduce((acc, y) => ({ ...acc, [y]: true }), {})
    const yearOptions = range(currentYear, FIRST_YEAR - 1, -1)
        .filter(y => !takenYears[y])
        .map(y => ({ value: y, label: `${y}` }))

    const onValidate = () => {
        if (!year) {
            dispatch(ToastrAction.error(i18n.allFieldsAreRequired))
            return
        }
        dispatch(RpqsAction.duplicateRpqs({ collectivityId: sourceRpqs.collectivityId, sourceYear: sourceRpqs.year, targetYear: year })).then(json => {
            if (json?.insert) {
                onClose()
                dispatch(push(`/rpqs/${json.year}/collectivite/${json.collectivityId}/dashboard`))
            }
        })
    }

    return (
        <Dialog open={open} maxWidth='sm' fullWidth>
            <DefaultDialogTitle title={i18n.duplicate} onClose={onClose}/>
            <DialogContent>
                <Grid container>
                    <Grid size={12}>
                        <Select
                            label={i18n.year}
                            options={yearOptions}
                            value={year}
                            onChange={setYear}
                            obligatory
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    {i18n.close}
                </Button>
                <Button onClick={onValidate} variant='contained' color='primary'>
                    {i18n.validate}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

DialogDuplicateRPQS.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    sourceRpqs: PropTypes.shape({ year: PropTypes.number, collectivityId: PropTypes.number }),
    existingYears: PropTypes.arrayOf(PropTypes.number),
}

export default DialogDuplicateRPQS